import { render, staticRenderFns } from "./AccountServiceHeader.vue?vue&type=template&id=2ebb96ed&scoped=true&"
import script from "./AccountServiceHeader.vue?vue&type=script&lang=ts&"
export * from "./AccountServiceHeader.vue?vue&type=script&lang=ts&"
import style0 from "./AccountServiceHeader.vue?vue&type=style&index=0&id=2ebb96ed&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebb96ed",
  null
  
)

export default component.exports